import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {
  ContactsService,
  PS_Relance_Doc_Result,
  PafListsService,
  SharedDataService,
  SimpleReponseResult,
  SuppliersService
} from 'ngx-paf-common';

import {
  GroupDescriptor,
  DataResult,
  process,
  State,  
  CompositeFilterDescriptor
} from "@progress/kendo-data-query";
import { Observable } from 'rxjs';

import { 
  PageChangeEvent, 
  PagerSettings ,
  DataStateChangeEvent,
  GridDataResult,
  FilterService
} from "@progress/kendo-angular-grid";

@Component({
  selector: 'relances-documentaire',
  templateUrl: './relances-documentaire.component.html',
  styleUrls: ['./relances-documentaire.component.scss'],
  encapsulation:ViewEncapsulation.None,  //Permet d'utiliser le style redefini pour la grille dans style.scss et non le style global Telerik
})
export class RelancesDocumentaireComponent implements OnInit {

  constructor(
    private pafLists: PafListsService,
    private contactsSvc: ContactsService,
    public sharedDataSvc: SharedDataService,
    private suppliersSvc: SuppliersService,) {
  }

  ngOnInit(): void {
    this.reloadList();
  }

  public get isAdmin(): boolean {
    return this.sharedDataSvc.isAdmin;
  }

  private _lstDocs: PS_Relance_Doc_Result[] = [];
  public lstDatas: DataResult;
  public state: State = {
    skip: 0,
    take: 100,    
    group:  [{ field: "SupplierName" }]
  };
  
  public pagerSettings:PagerSettings = {
    position: 'top',
    pageSizes: [20,50,100],
    previousNext: true,
    responsive: true,
    type:'numeric'
  }

  reloadList(): void {
    this.sharedDataSvc.WindowLock();
    this.suppliersSvc.GetRelanceDocList(0)
      .subscribe((results: PS_Relance_Doc_Result[]) => {
        results.forEach(d => {
          d.DateExpi = new Date(d.DateExpi);
          if (d.DateDerniereRelance) d.DateDerniereRelance = new Date(d.DateDerniereRelance);
          (<any>d).StatutTraitement=0;
        });
        this._lstDocs = results;
        this._lstDocs.sortObject('SupplierName');
        this.refreshDataGrid();
        this.results = [];
      },err=> this.sharedDataSvc.alert(err),
      ()=> this.sharedDataSvc.WindowUnlock());
  }


  pageChange({ skip, take }: PageChangeEvent): void {
    this.state.skip = skip;
    this.state.take = take;
    this.refreshDataGrid();
  }
  refreshDataGrid():void{
        this.lstDatas = process(this._lstDocs,  this.state);
  }
  public dataStateChange(state: DataStateChangeEvent): void {
    state.group = this.state.group;
    this.state = state;
    this.refreshDataGrid();
  }

  public groupChange(groups: GroupDescriptor[]): void {
    this.state.group = groups;
    this.refreshDataGrid();
  }

  private _addResult(res:SimpleReponseResult):void{
    this.results.splice(0, 0, {'SupplierName':this.SupplierName(res.Id), 'datas':res});
    this._lstDocs.filter(d=>d.SupplierId==res.Id).forEach(d=>{      
      (<any>d).StatutTraitement=(res.Ok?1:2);
    });
  }

  public relancer(supplierName: string) {
    let supplierId: number = this._lstDocs.find(d => d.SupplierName == supplierName)?.SupplierId;
    this.sharedDataSvc.WindowLock();
    this._relanceDocs(supplierId)
      .subscribe((res: SimpleReponseResult) => {
        this._addResult(res);
      },
        (error: any) => { this.sharedDataSvc.alert(error) }
        , () => {
          this.sharedDataSvc.WindowUnlock();
          this.refreshDataGrid();
        });
  }

  private _relanceDocs(supplierId: number): Observable<SimpleReponseResult> {
    return this.suppliersSvc.PostRelanceDocuments(supplierId);
  }

  public results: any[] = [];

  private _supplierIds: number[] = [];
  public relancerTout(confirme: boolean = false): void {
    if (confirme != true) {
      this.sharedDataSvc.confirm('Relancer tous les fournisseurs?', () => { this.relancerTout(true) }, null);
      return;
    }
    this._supplierIds = this._lstDocs.distinctValues('SupplierId').map(d => d.SupplierId);
    this.sharedDataSvc.WindowLock();
    for (let i: number = 0; i < 5; i++) {
      this._relanceDocsAsync();
    }
  }

  private _relanceDocsAsync(): void {
    if (this._supplierIds.length == 0) {
      this.sharedDataSvc.WindowUnlock();
      return;
    }
    let supplierId: number = this._supplierIds.splice(0, 1)[0];
    this.suppliersSvc.PostRelanceDocuments(supplierId)
    .subscribe(res=>{
      this._addResult(res);
      this._relanceDocsAsync();
    },
    (error: any) => {
      this.sharedDataSvc.alert(error);
    });
  }

  SupplierName(supplierId:number):string{
    return this._lstDocs.find(d=>d.SupplierId==supplierId)?.SupplierName;
  }

  public getDocStateImg():string{
    return './assets/images/trafficLight.png';  
  }

  public getDocStateImgClass(state:string):string{
    if (!state) return '';
    return 'img-docstate-'+state.toLowerCase();
  }

  public trafficLightHtml(supplierName:string):any{
    let doc:PS_Relance_Doc_Result = this._lstDocs.find(d => d.SupplierName == supplierName);
    let id:number = (<any>doc)?.StatutTraitement;
    let retString:string=
      '<div class="ml-2 img-docstate-container-combo img-docstate-container">'+
      '<img src="'+this.getDocStateImg()+'" class="img-docstate img-docstate-{0}" />'+
      '</div>';     
    if (id==2){      
      return retString.replace('{0}','rouge');
    } else if (id==1){
      return retString.replace('{0}','vert');
    } else {
      return retString.replace('{0}','orange');
    }
  }
  public getResultsMessages(supplierName:string):string[]{
    let result:any=this.results.find(r=>r.SupplierName==supplierName);
    if (!result) return [];
    return result.datas?.Message?.split('|');
  }

  get nothingTodo():boolean{
    return !this._lstDocs.find(d=>(<any>d).StatutTraitement!=1);
  }
  
  dejaTraite(supplierName:string):boolean{
    return !!this.results.find(r=>r.SupplierName==supplierName && (<any>r).datas.Ok);
  }

  getSupplierLink(supplierName:string):string{
    let firstDoc: PS_Relance_Doc_Result=this._lstDocs.find(d=>d.SupplierName==supplierName);
    if (!firstDoc) return '';
    return '/supplier-details/'+<string>(<any>firstDoc.SupplierId)+'/relances-documentaires';
  }
  btnRechargerListeClick(confirmed:boolean = false):void{
    if (this.results.length==0) confirmed=true;
    if (confirmed!=true){
      this.sharedDataSvc.confirm("Les fournisseurs déjà relancés seront retirés de la liste. Confirmez-vous le rechargement?",
      ()=>this.btnRechargerListeClick(true),
      null);
      return;
    }
    this.reloadList();
  }


  public gridFiltersChange(values: any[], filterService: FilterService, column: any): void {
    filterService.filter({
      filters: values.map((value) => ({
        field: column.field,
        operator: "eq",
        value,
      })),
      logic: "or",
    });
  }
}
